import { SetupPage, TabPermission } from 'src/app/core/interfaces/permissions';
import { Administrative } from 'src/permissions/product-lines/administrative/administrative.setup';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

const path = 'roles';
const title = 'PAGE.USERS_ROLES.ROLES.TITLE';
const parent: SetupPage = Administrative.pages.usersRoles;
const res = ['addRole', 'editRole', 'actions', 'actions.deleteRole'];

export const UsersRolesRolesTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
